export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /**
     * Hamburger
     */
    $('.hamburger').on('click', function(event) {
      event.preventDefault();
      $(this).toggleClass('is-active');
      $('body').toggleClass('menu-open');
      $('header .nav-primary').toggleClass('d-none mobile');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js